import { render, staticRenderFns } from "./IconBrex.vue?vue&type=template&id=276cc9d6"
import script from "./IconBrex.vue?vue&type=script&lang=js"
export * from "./IconBrex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports